module.exports = __webpack_public_path__ + "img/Mills_SuperOK-67.c139c9ce.jpg";